"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var customValidators = [{
  key: 1,
  text: "Alfabetico",
  value: "^[A-Z]+$"
}, {
  key: 2,
  text: "Alfanumerico",
  value: "^[0-9A-Z]+$"
}, {
  key: 3,
  text: "Decimal",
  value: "^(\\d*\\.)?\\d+$"
}, {
  key: 4,
  text: "Email",
  value: '^(("[\\w-\\s]+")|([\\w-]+(?:\\.[\\w-]+)*)|("[\\w-\\s]+")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)'
}, {
  key: 5,
  text: "Entero",
  value: "^[0-9]*$"
}];
var _default = customValidators;
exports.default = _default;